import { ref, watch } from 'vue';
import store from '@/store';
import { config } from '@/config.js';
import { useSearchDebounce } from '@/composables/front/common/useSearchDebounce';

/**
 * useFetchPaginated — fetch paginado + búsqueda + filtro tipo contra un alias Vuex.
 *
 * @param {object} options
 * @param {string} options.vuexAlias     — clave en api-routes.js (e.g. 'front.perfil.pedidos')
 * @param {string} options.errorMessage  — mensaje de fallback si el fetch falla
 */
export function useFetchPaginated({ vuexAlias, errorMessage }) {
    const items      = ref([]);
    const loading    = ref(false);
    const error      = ref(null);
    const meta       = ref(null);
    const page       = ref(1);
    const perPage    = ref(5);
    const { search, debouncedSearch } = useSearchDebounce({ delay: 600, minChars: 1 });
    const tipo       = ref('actuales');
    const hasFetched = ref(false);

    const fetch = (pageNum = page.value) => {
        loading.value = true;
        error.value   = null;
        page.value    = pageNum;

        store.dispatch(config.getVuexAlias(vuexAlias), {
            filters: {
                page:     page.value,
                per_page: perPage.value,
                search:   search.value,
                tipo:     tipo.value,
            },
        })
            .then(res => {
                items.value    = res.data.data;
                meta.value     = res.data.meta;
                page.value     = res.data.meta.current_page;
                perPage.value  = res.data.meta.per_page;
                hasFetched.value = true;
            })
            .catch(err => { error.value = err?.message || errorMessage; })
            .finally(() => { loading.value = false; });
    };

    watch(debouncedSearch, () => {
        page.value = 1;
        fetch(1);
    });

    watch(tipo, () => {
        page.value = 1;
        fetch(1);
    });

    return { items, loading, error, meta, page, perPage, search, tipo, hasFetched, fetch };
}
